import React from 'react'
import RecruiterForgotPassword from '../../components/recruitercomponents/RecruiterForgotPassword';
function RecruiterForgotPasswordPage() {
  return (
    <div>
     {/* <Nav /> */}
     <RecruiterForgotPassword />
    {/* <Footer /> */}
    </div>
  )
}
export default RecruiterForgotPasswordPage;